import countries from 'i18n-iso-countries'

const getCountries = (lang) =>
  new Promise((resolve) => {
    if (lang === 'no') {
      lang = 'nb'
    }
    import(
      /* webpackChunkName: "[request]" */ `i18n-iso-countries/langs/${lang}.json`
    ).then((langFile) => {
      countries.registerLocale(langFile)
      resolve(countries)
    })
  })

export default getCountries
